import { render, staticRenderFns } from "./componentMenuImage.vue?vue&type=template&id=f2c998cc&scoped=true"
import script from "./componentMenuImage.vue?vue&type=script&lang=js"
export * from "./componentMenuImage.vue?vue&type=script&lang=js"
import style0 from "./componentMenuImage.vue?vue&type=style&index=0&id=f2c998cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c998cc",
  null
  
)

export default component.exports